import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppInsightsService, SeverityLevel } from '@markpieszak/ng-application-insights';
import { AppUrls } from '../../utility/appurls';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  homeUrl: string;

  constructor(private appInsightsService: AppInsightsService, private router: Router) {
    this.homeUrl = AppUrls.home();
  }

  ngOnInit() {
    this.appInsightsService.trackException(
      new Error('Attempted to navigate to page that was not found. URL: ' + this.router.url),
      null,
      null,
      null,
      SeverityLevel.Information,
    );
  }
}
